<template>
	<div class="page">
		<div class="page-header">
			<div class="page-header-inner">
				<div class="page-kicker">Catalyst Entry Search</div>
				<h1 class="page-title">Periodic Table Explorer</h1>
				<p class="page-desc">
					Select one or more elements to search catalyst entries by composition.
				</p>
			</div>
		</div>

		<div class="inputSelect">
			<el-input
				placeholder=""
				type="text"
				v-model="input3"
				@keyup.enter="toSearch(currentPage)"
				@clear="toClear"
				clearable
			>
				<template #prepend>
					<el-select v-model="select" placeholder="by Elements" style="width: 130px;">
						<el-option label="by Elements" value="1"></el-option>
					</el-select>
				</template>
				<template #append>
					<el-button icon="el-icon-search" @click="toSearch(currentPage)"></el-button>
				</template>
			</el-input>
		</div>

		<el-card class="box-card periodic-card">
			<div class="element" id="element">
				<div class="element-top">
					<div v-for="column in topColumn" :key="column.Name" class="column">
						<div
							v-for="element in column.elementArr"
							:key="element.AT || Math.random()"
							class="base-element column-element"
							:class="[
								element.Name ? getElementClass(element.Name) : 'element-empty',
								element.Name && isSelected(element.Name) ? 'element-selected' : ''
							]"
							@click="element.Name && handleClickElement(element)"
						>
							<template v-if="element.Name">
								<div class="element-symbol">{{ element.Name }}</div>
								<div class="AT">{{ element.AT }}</div>
							</template>
						</div>
					</div>
				</div>

				<div class="element-bottom">
					<div>
						<div class="line">
							<div
								v-for="element in LaColumn"
								:key="element.AT"
								class="base-element line-element"
								:class="[
									getElementClass(element.Name),
									isSelected(element.Name) ? 'element-selected' : ''
								]"
								@click="handleClickElement(element)"
							>
								<div class="element-symbol">{{ element.Name }}</div>
								<div class="AT">{{ element.AT }}</div>
							</div>
						</div>
						<div class="line">
							<div
								v-for="element in AcColumn"
								:key="element.AT"
								class="base-element line-element"
								:class="[
									getElementClass(element.Name),
									isSelected(element.Name) ? 'element-selected' : ''
								]"
								@click="handleClickElement(element)"
							>
								<div class="element-symbol">{{ element.Name }}</div>
								<div class="AT">{{ element.AT }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-card>

		<el-card class="box-card result-card" v-if="input3 && isSearch">
			<el-table
				:data="tableData"
				stripe
				style="width: 100%; cursor: pointer;"
				@row-click="goTo"
				empty-text="暂无数据"
				v-loading="loading"
				height="500"
				:header-cell-style="{ color: '#0f274d', 'font-weight': '700', 'background': '#f8fafc' }"
			>
				<el-table-column prop="model" label="model" sortable align="center" fixed="left">
					<template #default="{ row }">
						<span class="model-link">{{ row.model }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="coordination_number" label="Coordination Number" sortable align="center">
					<template #default="{ row }">
						{{ parseInt(row.coordination_number) }}
					</template>
				</el-table-column>

				<el-table-column
					prop="o2_bander_charge"
					label="Charge of the Central Metal Atom"
					sortable
					width="300"
					align="center"
				>
					<template #default="{ row }">
						{{ row.o2_bander_charge.toFixed(5) }}
					</template>
				</el-table-column>

				<el-table-column prop="predicted_performance" label="predicted_performance" sortable align="center">
					<template #default="{ row }">
						{{ formatMaybeNumber(row.predicted_performance, 5) }}
					</template>
				</el-table-column>
			</el-table>

			<div class="pagInation">
				<el-pagination
					background
					layout="prev, pager, next, total"
					:total="total"
					:page-size="pageSize"
					:current-page="currentPage"
					@current-change="handleCurrentChange"
				>
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
export default {
	name: 'periodicTable',
	data() {
		return {
			datalistTotal: null,
			input3: '',
			select: '',
			topColumn: [
				{
					Name: '1',
					elementArr: [
						{ Name: 'H', AT: 1, color: 0, AtomicWeightF: 1.00794 },
						{ Name: 'Li', AT: 3, color: 1, AtomicWeightF: 6.941 },
						{ Name: 'Na', AT: 11, color: 1, AtomicWeightF: 22.9898 },
						{ Name: 'K', AT: 19, color: 1, AtomicWeightF: 39.0983 },
						{ Name: 'Rb', AT: 37, color: 1, AtomicWeightF: 85.4678 },
						{ Name: 'Cs', AT: 55, color: 1, AtomicWeightF: 132.9054 },
						{ Name: 'Fr', AT: 87, color: 1, AtomicWeightF: 223 }
					]
				},
				{
					Name: '2',
					elementArr: [
						{ Name: 'Be', AT: 4, color: 2, AtomicWeightF: 9.01218 },
						{ Name: 'Mg', AT: 12, color: 2, AtomicWeightF: 24.305 },
						{ Name: 'Ca', AT: 20, color: 2, AtomicWeightF: 40.08 },
						{ Name: 'Sr', AT: 38, color: 2, AtomicWeightF: 87.62 },
						{ Name: 'Ba', AT: 56, color: 2, AtomicWeightF: 137.32 },
						{ Name: 'Ra', AT: 88, color: 2, AtomicWeightF: 226.0254 }
					]
				},
				{
					Name: '3',
					elementArr: [
						{ Name: 'Sc', AT: 21, color: 2, AtomicWeightF: 44.9559 },
						{ Name: 'Y', AT: 39, color: 2, AtomicWeightF: 88.9059 },
						{},
						{}
					]
				},
				{
					Name: '4',
					elementArr: [
						{ Name: 'Ti', AT: 22, color: 2, AtomicWeightF: 47.9 },
						{ Name: 'Zr', AT: 40, color: 2, AtomicWeightF: 91.22 },
						{ Name: 'Hf', AT: 72, color: 9, AtomicWeightF: 178.49 },
						{ Name: 'Rf', AT: 104, color: 9, AtomicWeightF: 261 }
					]
				},
				{
					Name: '5',
					elementArr: [
						{ Name: 'V', AT: 23, color: 2, AtomicWeightF: 50.9415 },
						{ Name: 'Nb', AT: 41, color: 2, AtomicWeightF: 92.9064 },
						{ Name: 'Ta', AT: 73, color: 9, AtomicWeightF: 180.9479 },
						{ Name: 'Db', AT: 105, color: 9, AtomicWeightF: 262 }
					]
				},
				{
					Name: '6',
					elementArr: [
						{ Name: 'Cr', AT: 24, color: 2, AtomicWeightF: 51.996 },
						{ Name: 'Mo', AT: 42, color: 2, AtomicWeightF: 95.94 },
						{ Name: 'W', AT: 74, color: 9, AtomicWeightF: 183.85 },
						{ Name: 'Sg', AT: 106, color: 9, AtomicWeightF: 263 }
					]
				},
				{
					Name: '7',
					elementArr: [
						{ Name: 'Mn', AT: 25, color: 2, AtomicWeightF: 54.938 },
						{ Name: 'Tc', AT: 43, color: 2, AtomicWeightF: 98 },
						{ Name: 'Re', AT: 75, color: 9, AtomicWeightF: 186.207 },
						{ Name: 'Bh', AT: 107, color: 9, AtomicWeightF: 258 }
					]
				},
				{
					Name: '8',
					elementArr: [
						{ Name: 'Fe', AT: 26, color: 2, AtomicWeightF: 55.847 },
						{ Name: 'Ru', AT: 44, color: 2, AtomicWeightF: 101.07 },
						{ Name: 'Os', AT: 76, color: 9, AtomicWeightF: 190.2 },
						{ Name: 'Hs', AT: 108, color: 9, AtomicWeightF: 269.1336 }
					]
				},
				{
					Name: '9',
					elementArr: [
						{ Name: 'Co', AT: 27, color: 2, AtomicWeightF: 58.9332 },
						{ Name: 'Rh', AT: 45, color: 2, AtomicWeightF: 102.9055 },
						{ Name: 'Ir', AT: 77, color: 9, AtomicWeightF: 192.22 },
						{ Name: 'Mt', AT: 109, color: 9, AtomicWeightF: 227.154 }
					]
				},
				{
					Name: '10',
					elementArr: [
						{ Name: 'Ni', AT: 28, color: 2, AtomicWeightF: 58.7 },
						{ Name: 'Pd', AT: 46, color: 2, AtomicWeightF: 106.4 },
						{ Name: 'Pt', AT: 78, color: 9, AtomicWeightF: 195.09 },
						{ Name: 'Ds', AT: 110, color: 9, AtomicWeightF: 282.166 }
					]
				},
				{
					Name: '11',
					elementArr: [
						{ Name: 'Cu', AT: 29, color: 2, AtomicWeightF: 63.546 },
						{ Name: 'Ag', AT: 47, color: 2, AtomicWeightF: 107.868 },
						{ Name: 'Au', AT: 79, color: 9, AtomicWeightF: 196.9665 },
						{ Name: 'Rg', AT: 111, color: 9, AtomicWeightF: 282.169 }
					]
				},
				{
					Name: '12',
					elementArr: [
						{ Name: 'Zn', AT: 30, color: 2, AtomicWeightF: 60.38 },
						{ Name: 'Cd', AT: 48, color: 2, AtomicWeightF: 112.41 },
						{ Name: 'Hg', AT: 80, color: 9, AtomicWeightF: 200.59 },
						{ Name: 'Cn', AT: 112, color: 9, AtomicWeightF: 286.179 }
					]
				},
				{
					Name: '13',
					elementArr: [
						{ Name: 'B', AT: 5, color: 4, AtomicWeightF: 10.81 },
						{ Name: 'Al', AT: 13, color: 4, AtomicWeightF: 26.9815 },
						{ Name: 'Ga', AT: 31, color: 2, AtomicWeightF: 69.72 },
						{ Name: 'In', AT: 49, color: 2, AtomicWeightF: 114.82 },
						{ Name: 'Tl', AT: 81, color: 9, AtomicWeightF: 204.37 },
						{ Name: 'Nh', AT: 113, color: 9, AtomicWeightF: 286.182 }
					]
				},
				{
					Name: '14',
					elementArr: [
						{ Name: 'C', AT: 6, color: 7, AtomicWeightF: 12.011 },
						{ Name: 'Si', AT: 14, color: 4, AtomicWeightF: 28.0855 },
						{ Name: 'Ge', AT: 32, color: 2, AtomicWeightF: 72.59 },
						{ Name: 'Sn', AT: 50, color: 2, AtomicWeightF: 118.69 },
						{ Name: 'Pb', AT: 82, color: 9, AtomicWeightF: 207.2 },
						{ Name: 'Fl', AT: 114, color: 9, AtomicWeightF: 290.192 }
					]
				},
				{
					Name: '15',
					elementArr: [
						{ Name: 'N', AT: 7, color: 7, AtomicWeightF: 14.0067 },
						{ Name: 'P', AT: 15, color: 7, AtomicWeightF: 30.9738 },
						{ Name: 'As', AT: 33, color: 4, AtomicWeightF: 74.9216 },
						{ Name: 'Sb', AT: 51, color: 4, AtomicWeightF: 121.75 },
						{ Name: 'Bi', AT: 83, color: 9, AtomicWeightF: 208.9804 },
						{ Name: 'Mc', AT: 115, color: 9, AtomicWeightF: 290.196 }
					]
				},
				{
					Name: '',
					elementArr: [
						{ Name: 'O', AT: 8, color: 7, AtomicWeightF: 15.9994 },
						{ Name: 'S', AT: 16, color: 7, AtomicWeightF: 32.06 },
						{ Name: 'Se', AT: 34, color: 7, AtomicWeightF: 78.96 },
						{ Name: 'Te', AT: 52, color: 4, AtomicWeightF: 127.6 },
						{ Name: 'Po', AT: 84, color: 9, AtomicWeightF: 209 },
						{ Name: 'Lv', AT: 116, color: 9, AtomicWeightF: 293.205 }
					]
				},
				{
					Name: '16',
					elementArr: [
						{ Name: 'F', AT: 9, color: 6, AtomicWeightF: 18.9984 },
						{ Name: 'Cl', AT: 17, color: 6, AtomicWeightF: 35.453 },
						{ Name: 'Br', AT: 35, color: 6, AtomicWeightF: 79.904 },
						{ Name: 'I', AT: 53, color: 6, AtomicWeightF: 126.9045 },
						{ Name: 'At', AT: 85, color: 9, AtomicWeightF: 210 },
						{ Name: 'Ts', AT: 117, color: 9, AtomicWeightF: 294.211 }
					]
				},
				{
					Name: '17',
					elementArr: [
						{ Name: 'He', AT: 2, color: 0, AtomicWeightF: 4.002 },
						{ Name: 'Ne', AT: 10, color: 10, AtomicWeightF: 20.179 },
						{ Name: 'Ar', AT: 18, color: 10, AtomicWeightF: 39.948 },
						{ Name: 'Kr', AT: 36, color: 10, AtomicWeightF: 83.8 },
						{ Name: 'Xe', AT: 54, color: 10, AtomicWeightF: 131.3 },
						{ Name: 'Rn', AT: 86, color: 10, AtomicWeightF: 222 },
						{ Name: 'Og', AT: 118, color: 10, AtomicWeightF: 295.216 }
					]
				}
			],
			LaColumn: [
				{ Name: 'La', AT: 57, color: 8, AtomicWeightF: 138.9055 },
				{ Name: 'Ce', AT: 58, color: 8, AtomicWeightF: 140.12 },
				{ Name: 'Pr', AT: 59, color: 8, AtomicWeightF: 140.9077 },
				{ Name: 'Nd', AT: 60, color: 8, AtomicWeightF: 144.24 },
				{ Name: 'Pm', AT: 61, color: 8, AtomicWeightF: 145 },
				{ Name: 'Sm', AT: 62, color: 8, AtomicWeightF: 150.4 },
				{ Name: 'Eu', AT: 63, color: 8, AtomicWeightF: 151.96 },
				{ Name: 'Gd', AT: 64, color: 8, AtomicWeightF: 157.25 },
				{ Name: 'Tb', AT: 65, color: 8, AtomicWeightF: 158.9254 },
				{ Name: 'Dy', AT: 66, color: 8, AtomicWeightF: 162.5 },
				{ Name: 'Ho', AT: 67, color: 8, AtomicWeightF: 164.9304 },
				{ Name: 'Er', AT: 68, color: 8, AtomicWeightF: 167.26 },
				{ Name: 'Tm', AT: 69, color: 8, AtomicWeightF: 168.9342 },
				{ Name: 'Yb', AT: 70, color: 8, AtomicWeightF: 173.04 },
				{ Name: 'Lu', AT: 71, color: 8, AtomicWeightF: 174.96 }
			],
			AcColumn: [
				{ Name: 'Ac', AT: 89, color: 9, AtomicWeightF: 227.0278 },
				{ Name: 'Th', AT: 90, color: 9, AtomicWeightF: 232.0381 },
				{ Name: 'Pa', AT: 91, color: 9, AtomicWeightF: 231.0359 },
				{ Name: 'U', AT: 92, color: 9, AtomicWeightF: 238.029 },
				{ Name: 'Np', AT: 93, color: 9, AtomicWeightF: 237 },
				{ Name: 'Pu', AT: 94, color: 9, AtomicWeightF: 244 },
				{ Name: 'Am', AT: 95, color: 9, AtomicWeightF: 243 },
				{ Name: 'Cm', AT: 96, color: 9, AtomicWeightF: 247 },
				{ Name: 'Bk', AT: 97, color: 9, AtomicWeightF: 247 },
				{ Name: 'Cf', AT: 98, color: 9, AtomicWeightF: 251 },
				{ Name: 'Es', AT: 99, color: 9, AtomicWeightF: 252 },
				{ Name: 'Fm', AT: 100, color: 9, AtomicWeightF: 257 },
				{ Name: 'Md', AT: 101, color: 9, AtomicWeightF: 258 },
				{ Name: 'No', AT: 102, color: 9, AtomicWeightF: 259 },
				{ Name: 'Lr', AT: 103, color: 9, AtomicWeightF: 260 }
			],
			data: [],
			tableData: [],
			currentPage: 1,
			pageSize: 15,
			total: 0,
			loading: false,
			isSearch: false
		}
	},
	methods: {
		getElementClass(name) {
			const highlightElements = new Set([
				'Ag', 'Au', 'Ca', 'Cd', 'Ce', 'Co', 'Cr', 'Cu', 'Fe', 'Gd', 'Hf', 'Ir',
				'La', 'Lu', 'Mg', 'Mn', 'Mo', 'Nb', 'Nd', 'Ni', 'Os', 'Pd', 'Pt', 'Re',
				'Rh', 'Ru', 'Sc', 'Ta', 'Tc', 'Ti', 'V', 'W', 'Y', 'Zn', 'Zr'
			])

			const nonmetalElements = new Set(['B', 'C', 'N', 'O', 'F', 'Si', 'P', 'S', 'Cl'])

			if (highlightElements.has(name)) return 'element-highlight'
			if (nonmetalElements.has(name)) return 'element-nonmetal'
			return 'element-default'
		},

		isSelected(name) {
			return this.data.includes(name)
		},

		formatMaybeNumber(val, digits = 5) {
			if (val === null || val === undefined || val === '') return ''
			const num = typeof val === 'number' ? val : parseFloat(String(val))
			if (Number.isFinite(num)) return num.toFixed(digits)
			return String(val)
		},

		getDatalistTotal() {
			this.$api.news.getDatalistTotal().then((res) => {
				const total = res && res.data && res.data.data && res.data.data.total
				this.datalistTotal = typeof total === 'number' ? total : null
			}).catch(() => {
				this.datalistTotal = null
			})
		},

		handleClickElement(val) {
			const idx = this.data.indexOf(val.Name)

			if (idx > -1) {
				this.data.splice(idx, 1)
			} else {
				if (this.data.length >= 20) {
					this.$message({
						message: '最多添加20项元素',
						type: 'warning'
					})
					return false
				}
				this.data.push(val.Name)
			}

			this.input3 = this.data.join('')
		},

		handClose() {
			this.$emit('handleClose')
		},

		toChange(e) {
			let arr = []
			arr = e.split('_')
			if (arr.length > 1) {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].length != this.data[i].length) {
						arr.splice(i, 1)
					}
				}
			} else if (arr.length == 1) {
				arr = []
			}

			this.input3 = ''
			arr.forEach((i) => {
				this.input3 += i
			})
			this.data = arr
		},

		toClear() {
			this.data = []
			this.isSearch = false
			this.currentPage = 1
		},

		toSearch(page) {
			if (this.$store.state.name && this.input3 != this.$store.state.name) {
				this.currentPage = 1
				page = 1
			}
			if (this.input3 == '') {
				return
			}
			this.loading = true
			this.isSearch = true
			let data = {
				model: this.input3,
				page: page ? page : this.currentPage,
				per_page: this.pageSize
			}
			this.$api.news.getList(data).then((res) => {
				this.loading = false
				this.tableData = res.data.data.data
				this.total = res.data.data.total
				this.$store.dispatch('saveAsync', this.tableData)
				this.$store.dispatch('saveAsyncTableTotal', this.total)
				this.$store.dispatch('saveAsyncInput', this.input3)
			})
		},

		goTo(e) {
			localStorage.setItem('periodic', this.input3)
			this.$router.push({
				name: 'StudentFeedback',
				query: {
					id: e.id
				}
			})
		},

		handleCurrentChange(val) {
			this.currentPage = val
			this.$store.dispatch('saveAsyncTablePageNum', this.currentPage)
			this.toSearch(this.currentPage)
		}
	},

	created() {
		this.getDatalistTotal()
		let histroyList = this.$store.state.list
		let histroyInput = this.$store.state.name
		let tableTotal = this.$store.state.tableTotal
		let currentPage = this.$store.state.pageNum
		if (histroyList.length > 0) {
			this.tableData = histroyList
			this.total = tableTotal
			this.currentPage = currentPage
			this.isSearch = true
		}
		if (histroyInput) {
			this.input3 = histroyInput
		}
	},

	activated() {
		if (this.datalistTotal === null) {
			this.getDatalistTotal()
		}
	}
}
</script>

<style scoped>
.page {
	min-height: 100vh;
	position: relative;
	padding: 24px 0 64px;
	box-sizing: border-box;
	background: #eef2f6;
	font-family: 'Open Sans Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.page-header,
.inputSelect,
.box-card {
	width: 82%;
	margin-left: auto;
	margin-right: auto;
}

.page-header {
	padding: 18px 0 24px;
	border-bottom: 1px solid #dde5ee;
	margin-bottom: 24px;
}

.page-header-inner {
	max-width: 980px;
}

.page-kicker {
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: #6b7280;
	margin-bottom: 10px;
}

.page-title {
	margin: 0 0 10px;
	font-size: 34px;
	font-weight: 700;
	line-height: 1.2;
	color: #1f4fa3;
}

.page-desc {
	margin: 0;
	font-size: 18px;
	line-height: 1.8;
	color: #475569;
	max-width: 900px;
}

.inputSelect {
	margin-top: 24px;
}

.box-card {
	margin-top: 24px;
	border-radius: 8px;
	border: 1px solid #dde5ee;
	box-shadow: none !important;
	overflow: hidden;
	background: #f8fafc;
}

.periodic-card {
	background: #f8fafc;
}

.result-card {
	background: #f8fafc;
}

.element {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 18px 20px 20px;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
}

.element-top {
	display: flex;
	justify-content: center;
	align-items: flex-end;
}

.column {
	width: 64px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
}

.line {
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 8px 0;
}

.base-element {
	width: 52px;
	height: 52px;
	margin: 6px;
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	cursor: pointer;
	box-sizing: border-box;
	border: 1px solid #d9e2ec;
	border-radius: 0;
	transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, outline 0.15s ease;
}

.element-symbol {
	font-size: 18px;
	font-weight: 700;
	line-height: 1;
	color: #23324a;
}

.AT {
	margin-top: 4px;
	font-size: 11px;
	font-weight: 500;
	color: #64748b;
	line-height: 1;
}

.column-element {
	margin-top: 6px;
}

.line-element {
	margin: 0 6px;
}

.base-element:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 16px rgba(15, 39, 77, 0.08);
	border-color: #b9c9df;
	z-index: 2;
}

.element-selected {
	border-color: #1f4fa3 !important;
	outline: 2px solid #1f4fa3;
	outline-offset: 0;
	box-shadow: 0 0 0 2px rgba(31, 79, 163, 0.08);
	z-index: 3;
}

.element-empty {
	background: transparent !important;
	border: none !important;
	box-shadow: none !important;
	cursor: default !important;
	outline: none !important;
}

.element-highlight {
	background: #F9F6ED;
}

.element-nonmetal {
	background: #FADBDB;
}

.element-default {
	background: #E3ECFB;
}

.element-bottom {
	display: flex;
	align-items: center;
	margin-top: 14px;
}

.model-link {
	color: #1f4fa3;
	font-weight: 600;
}

.pagInation {
	margin: 20px auto 0;
	text-align: center;
}



.datalist-total {
	width: 82%;
	padding-top: 16px;
	margin: auto 0;
	text-align: right;
	color: #64748b;
	font-size: 16px;
}

.datalist-total-num {
	color: #1f4fa3;
	font-weight: 700;
	margin-left: 6px;
	font-size: 18px;
}

@media (max-width: 1200px) {
	.page-header,
	.inputSelect,
	.box-card {
		width: calc(100% - 28px);
	}

	.column {
		width: 58px;
	}

	.base-element {
		width: 46px;
		height: 46px;
		margin: 4px;
	}

	.element-symbol {
		font-size: 16px;
	}
}

@media (max-width: 960px) {
	.page-title {
		font-size: 28px;
	}

	.page-desc {
		font-size: 15px;
	}

	.element-top {
		overflow-x: auto;
		width: 100%;
		justify-content: flex-start;
		padding-bottom: 6px;
	}

	.element-bottom {
		overflow-x: auto;
		width: 100%;
		justify-content: flex-start;
		padding-bottom: 6px;
	}

	.base-element {
		width: 42px;
		height: 42px;
		margin: 4px;
		border-radius: 0;
	}

	.element-symbol {
		font-size: 14px;
	}

	.AT {
		font-size: 10px;
	}
}
</style>